export default __webpack_public_path__ + "static/media/Group_7477.6208463c.png";